import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useGTM from "./Hooks/useGTM";
import { useLanguage } from './Contexts/LanguageContext';

export default function PageTracking() {
    const { pathname } = useLocation();
    const { sendEvent } = useGTM();
    const { language } = useLanguage();

    useEffect(() => {
        const title = pathname.split('/').filter(part => part !== '').join(' - ');
        const pageTitle = title === '' ? 'Startsida' : title;

        sendEvent('page_view', {
            page_path: pathname,
            page_title: pageTitle + ` [${language}]`,
        });
    }, [pathname]); // runs on every route change. does it also need to run on language change?

    return null;
}